module.exports = __webpack_public_path__ + "9545ebe21dc8fd984d0d056f4fabd35d.png";